import MarketBase from './market-base';

export default class MarketBill extends MarketBase {
    Email: Array<string> = [];  
    Phone: Array<string> = [];   
    Price: Array<number> = [];
    Status: Array<number> = [];
}